import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { BeneficioStatus } from 'src/app/core/models/onboarding/BeneficioStatus';
import { OnboardingService } from 'src/app/core/services/onboarding';

@Component({
  selector: 'app-onboarding-beneficios',
  templateUrl: './onboarding-beneficios.component.html',
  styleUrls: ['./onboarding-beneficios.component.scss'],
})
export class OnboardingBeneficiosComponent implements OnInit {
  @Output() next = new EventEmitter();

  onboardingService = inject(OnboardingService);

  beneficioStatus?: BeneficioStatus;

  ngOnInit(): void {
    this.loadOnboardingStatus();
  }

  onNext(): void {
    this.next.emit();
  }

  private loadOnboardingStatus(): void {
    this.onboardingService
      .getBeneficiosStatus()
      .subscribe((beneficioStatus) => {
        this.beneficioStatus = beneficioStatus;
      });
  }
}
